import { useRef } from "react";

const useRenderCount = (page) => {
    useRef(0);
}
export default useRenderCount